
export default {
    loginAttempt({ dispatch }, payload) {
        const newPayload = {
            userDetails: payload.userDetails,
            notify: payload.notify,
            closeAnimation: payload.closeAnimation
        }

        dispatch('login', newPayload);
    },
    // eslint-disable-next-line no-unused-vars
    login({ commit, state, dispatch }, payload) {

        if (state.isUserLoggedIn()) {
            if(payload.closeAnimation) payload.closeAnimation();

            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });

            location.reload();
            return false
        }

        // eslint-disable-next-line no-undef
        axios.post(apiUrl+'/auth/login', {
            email: payload.userDetails.email,
            password: payload.userDetails.password
        })
        .then(function (response) {
            let data = response.data;
            if(data.code === 200){
                let user = data.data.user;
                let token = data.data.token;

                let roles = {
                    1: 'gd',
                    2: 'ld',
                    3: 'd',
                    4: 'u',
                };

                localStorage.setItem('loggedIn', 'true');
                localStorage.setItem('userInfo', JSON.stringify(user));
                localStorage.setItem('userRole', roles[user.type_id]);
                localStorage.setItem('token', token);
                window.userInfo = user;
                window.token = token;

                location.reload();
                return false;
            }else{
                if (payload.closeAnimation) payload.closeAnimation();
                payload.notify({
                    time: 2500,
                    title: 'Error',
                    text: data.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
        });
    }
}
